import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseProtoDto } from '../../../shared/modules/base/dtos/base-proto.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { PricingTierItemDto } from '../../../shared/modules/pricing-tier-items/dtos/pricing-tier-item.dto';
import { VehicleCategoryAvailabilityModeEnum } from '../../../shared/modules/vehicle-categories/enums/vehicle-category-availability-mode.enum';
import { AssetFeatureItemDto } from '../../asset-feature-items/dtos/asset-feature-item.dto';
import { AssetMetadataDto } from '../../asset-metadata/dtos/asset-metadata.dto';
import { AssetUnavailabilityItemDto } from '../../asset-unavailability-items/dtos/asset-unavailability-item.dto';
import { VehicleGroupDto } from '../../vehicle-groups/dtos/vehicle-group.dto';
import { AssetTypeEnum } from '../enums/asset-type.enum';

/**
 * Asset DTO for records
 */
@CaslSubject(AppSubjectEnum.ASSET)
export class AssetRecordDto extends BaseProtoDto {
	tenantOrgId?: string;
	areaUuid!: string;
	name!: string;
	type!: AssetTypeEnum;
	availabilityMode?: VehicleCategoryAvailabilityModeEnum;
	notes?: string;
	featureItems?: AssetFeatureItemDto[];
	metadata?: AssetMetadataDto[];
	pricingItems?: PricingTierItemDto[];
	unavailabilityItems?: AssetUnavailabilityItemDto[];
	files?: FileDto[];
	isTransferable?: boolean;
	vehicleGroup?: VehicleGroupDto;
}
